import React from "react"

import { css } from "@emotion/react"

import { Heading } from "@stratuscode/web-legos"

export const ComingSoon: React.FC = () => {
	return (
		<div css={containerStyle}>
			<Heading variant="h1-banner" icon="bullhorn">
				Coming Soon
			</Heading>
		</div>
	)
}

const containerStyle = css`
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	top: 3rem;
	right: 0;
	left: 0;
`
